
import { Vue, Component, VModel } from 'vue-property-decorator'
import { toggleIsFavoriteOnProjectGroup, toggleIsHiddenOnProjectGroup } from '@/utils/project'
import { timeFrom } from '@/utils/moments'

import ProjectAvatar from '@/components/Avatar/projectAvatar.vue'

@Component({
    components: {
        ProjectAvatar,
    },
})
export default class ProjectGroupListItem extends Vue {
    @VModel({ required: true }) projectGroup!: Record<string, any>

    timeFrom = timeFrom

    get userSettings(): Record<string, any> {
        return this.projectGroup.userSettings.data
    }

    set userSettings(value: Record<string, any>) {
        this.projectGroup.userSettings.data = value
    }

    get includeArchived() {
        return typeof this.$store.getters?.frontEndSettings?.includeArchived == 'boolean'
            ? this.$store.getters.frontEndSettings.includeArchived
            : true
    }

    // isFavorite
    loadingIsFavorite = false
    async toggleIsFavorite() {
        try {
            this.loadingIsFavorite = true
            this.userSettings = await toggleIsFavoriteOnProjectGroup(this.userSettings)
        } catch (error) {
            this.$store.commit('setGeneralErrorSnackBar', error)
        } finally {
            this.loadingIsFavorite = false
        }
    }

    // isHidden
    loadingIsHidden = false
    async toggleIsHidden() {
        try {
            this.loadingIsHidden = true
            this.userSettings = await toggleIsHiddenOnProjectGroup(this.userSettings)
        } catch (error) {
            this.$store.commit('setGeneralErrorSnackBar', error)
        } finally {
            this.loadingIsHidden = false
        }
    }
}
